import type { ReactNode } from 'react';

export const symbol_wine_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-180v-185q-99-14-154.5-79.7Q240-510.41 240-600v-210q0-12.75 8.63-21.38Q257.25-840 270-840h420q12.75 0 21.38 8.62Q720-822.75 720-810v210q0 89.59-55.5 155.3Q609-379 510-365v185h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H350q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100Zm150.5-287.5Q652-515 658-570H302q5 55 56.86 102.5 51.85 47.5 121 47.5 69.14 0 120.64-47.5ZM300-630h360v-150H300v150Zm180 210Z"
		/>
	</svg>
);
